import { Injectable } from '@angular/core';
import { BaseHttpService } from './base-http.service';
import { HttpClient } from '@angular/common/http';
import { StorageService } from '../storage/storage.service';
import { config } from '../../shared/config';
import { map } from 'rxjs/operators';
import { InstallationDashboardModel } from '../models/installation-dashboard.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InstallationDashboardService extends BaseHttpService{

  constructor(
    protected _http: HttpClient,
    protected _storage: StorageService,
  ) {
    super(_http, _storage);
  }

  getInstallationDashboardsByUnitId(unitId: number): Observable<any[]> {
    return this.get(config.generateApiUrl(`InstallationDashboard/unitId/${unitId}`, null, null, '2.2')).pipe(
      map((stat) => {
        return (stat['data'] || []) as InstallationDashboardModel[];
      })
    );
  }
}
